import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { AuthApiService, LoginDTO } from 'features/auth';

const { login } = AuthApiService();

type UseLoginPayload = LoginDTO & { persistSession: boolean };

export const useLogin = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: UseLoginPayload) => {
      const { Email, Password, UserType } = payload;

      return login({ Email, Password, UserType });
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data: any) => {
        if (data?.rs == 1) {
          message.success('Otp Send On Your Email');
        } else {
          message.error(data?.rm);
        }
      },
    },
  );
};
